import AuthInput from './auth-input';

export default AuthInput;
